module.exports = __webpack_public_path__ + "img/icon-sb-1sb_Mini_logo-boutique-16x16.5825348.svg";